module.exports = __webpack_public_path__ + "static/profile-tiny-b6c22aefa77e47204c098b1bf6b9e64d.jpg";